import { render } from "./FuneralViewFormType1.vue?vue&type=template&id=95bb1630&lang=true"
import script from "./FuneralViewFormType1.vue?vue&type=script&lang=js"
export * from "./FuneralViewFormType1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__